import moment from 'moment';

import { User as ActionTypes } from '../actionTypes';
import { time as constant } from '../../constants';

const create = payload => ({
  type: ActionTypes.CREATE,
  payload: payload.map(item => ({
    ...item,
    CreationDate: moment().format(constant.CREATE),
  })),
});

const override = payload => ({
  type: ActionTypes.OVERRIDE,
  payload,
});

const remove = payload => ({
  type: ActionTypes.REMOVE,
  payload,
});

const update = payload => ({
  type: ActionTypes.UPDATE,
  payload,
});

export default {
  create,
  override,
  remove,
  update,
};
